export enum RoomProvidersSummaryContext {
  Room = 'room',
  Hotel = 'hotel',
}

export interface ProviderOffer {
  operatorId: number;
  operatorName: string;
  price: number;
  bookingUrl?: string;
}

export interface ProviderOfferData {
  operatorId: number;
  name: string;
  price: number;
  isLowestPrice: boolean;
  redirectUrl?: string;
}

export enum SupplierType {
  Own = 'own',
  Operator = 'operator',
  Affiliate = 'affiliate',
}

export enum OffersFunnel {
  Hotel = 'hotel',
  Tour = 'tour',
}
